var lookBookGridCarousel = document.querySelectorAll('.js-look-book-grid');
var media = window.matchMedia('(min-width: 1025px)');

function initSliders() {
  if (!media.matches) {
    lookBookGridCarousel.forEach(function (el, index) {
      if (!el.swiper) {
        el.classList.add(`s${index}`);
        el.swiper = new Swiper(el, {
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
          a11y: false,
          slidesPerView: 'auto',
          spaceBetween: 16,
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
          },
        });
      }
    });
    
  }
}

function destroySliders() {
  lookBookGridCarousel.forEach(el => {
    if (el.swiper) {
      el.swiper.destroy(true, true);
      el.swiper = null;
    }
  });
}

function handleMediaChange(e) {
  if (e.matches) {
    destroySliders();
  } else {
    initSliders();
  }
}

initSliders();

media.addListener(handleMediaChange);